import React from "react";
import { Link } from "react-router-dom";

export default function ProjectSectionBox({ ProjectData }) {
  return (
    <>
      <div className="section-title text-center">
        <h2 className="wow fadeInUp aboutSectiontitle" data-wow-delay=".3s">
          {ProjectData.category_name} Projects
        </h2>
      </div>
      <div className="row pb-5">
        {ProjectData.projects.length > 0 ? (
          ProjectData.projects.map((valproj, index) => (
            <div className="col-xl-6 col-lg-6 col-md-6" key={index}>
              <div className="project-box-items style-margin">
                <div className="project-thumb">
                  <Link to={`/${ProjectData.category_slug}/${valproj.slug}`}>
                    <img
                      src={valproj.sort_img}
                      alt={valproj.image_alt}
                      title={valproj.image_title}
                    />
                    <img
                      src={valproj.sort_img}
                      alt={valproj.image_alt}
                      title={valproj.image_title}
                    />
                    {valproj.pricing !== "" && (
                      <span className="project-post-box text-light">
                        PRICE ₹{valproj.pricing}
                      </span>
                    )}
                  </Link>
                </div>
                <div className="project-content">
                  {valproj.location !== "" && (
                    <span className="location">
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      {valproj.location}
                    </span>
                  )}

                  <h3>
                    <Link to={`/${ProjectData.category_slug}/${valproj.slug}`}>
                      {valproj.title}
                    </Link>
                  </h3>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No Property available right now.</p>
        )}
      </div>
    </>
  );
}
